import { client } from "../../../../Infrastructure/agent";
export const requestService = {
  submitRequest: (approverId, requestorId, comment, productionIds, assetId) =>
    client.post("/requestapproval/SubmitRequest", {
      approverId,
      requestorId,
      comment,
      productionIds,
      assetId,
    }),

  loadRequest: (requestorId, year, assetId, statusId) =>
    client.post("/requestapproval/loadRequest", {
      requestorId,
      year,
      assetId,
      statusId,
    }),
  loadApprovals: (approverId, year, assetId, statusId) =>
    client.post("/requestapproval/LoadApprovals", {
      approverId,
      year,
      assetId,
      statusId,
    }),

  loadMyApprovals: (approverId) =>
    client.post("/requestapproval/LoadMyApprovals", {
      approverId,
    }),
  cancelRequest: (requestId, reason) =>
    client.post("/requestapproval/cancelRequest", { requestId, reason }),
  saveApprovedProduction: (prods, requests, comment, approver, assetId) =>
    client.post("/requestapproval/SaveNaocApproval", {
      prods,
      requests,
      comment,
      approver,
      assetId,
    }),
  declineRequest: (requests, reason, assetId) =>
    client.post("/requestapproval/declineRequest", {
      requests,
      reason,
      assetId,
    }),
};

